export default __webpack_public_path__ + "static/media/googleCalendarIcon.d8a218c8.svg";